module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.ShopItemRelatedTypes), function(ShopItemRelatedType) {
    return (_vm.RelatedShopItems[ShopItemRelatedType.id]) ? _c('div', {
      key: ShopItemRelatedType.id,
      staticClass: "uk-container uk-container-large uk-margin-medium-bottom"
    }, [_c('div', {}, [_c('h4', {
      staticClass: "tm-title-color",
      attrs: {
        "id": ("related-type-" + (ShopItemRelatedType.id))
      }
    }, [_vm._v(_vm._s(ShopItemRelatedType.name))])]), _vm._v(" "), _c('div', [_c('div', {
      staticClass: "uk-grid-medium uk-child-width-1-1 uk-child-width-1-2@s uk-child-width-1-3@m uk-child-width-1-4@l js-list-item-cards uk-grid",
      attrs: {
        "uk-grid": ""
      }
    }, _vm._l((_vm.RelatedShopItems[ShopItemRelatedType.id]), function(Product) {
      return _c('shop-item-block', {
        key: Product.ShopItem.id,
        attrs: {
          "shop-item": Product.ShopItem,
          "shop-item-prices": _vm.RelatedShopItemPrices[Product.ShopItem.id],
          "shop-item-warehouses": _vm.RelatedShopItemWarehouses[Product.ShopItem.id],
          "shop-order-item": _vm.page.ShopOrderItems[Product.ShopItem.id]
        },
        on: {
          "buy-shop-item": _vm.buy
        }
      })
    }))])]) : _vm._e()
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-141dddce","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/Shop/ShopItem/RelatedShopItems.vue
// module id = 81
// module chunks = 0